import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withRouter } from 'react-router-dom';
import Footer from '../layout/Footer';
import { ArrowLeft } from '../parts/svg.jsx';

const Information = props => {
  const availablePrices = [15, 50, 25];
  const [ selectedPrice, setSelectedPrice ] = useState(false);
  const [ isCustom, setIsCustom ] = useState(false);
  const [ data, setData ] = useState(false);

  useEffect(() => {
    document.body.classList.add('light');

    fetch(`${apiBase}/acf/v3/options/options`)
    .then(response => response.json())
    .then(json => {
      setData({
        fundsRaised: json.acf.funds_raised,
        masksSold: json.acf.masks_sold,
      })
    });

    return function cleanup(){
      document.body.classList.remove('dark');
    }
  }, []);
  return <div className='page page--covid transition'>
    <div className="page__content">
      <h1>We’re raising money for people in need.</h1>
      <p>As COVID-19 continues to spread around the world, we have produced one hundred and fifty non-medical face masks for purchase. By increasing quantities of non-medical face masks for civilians, we aim to help ensure that there are enough medical-grade N-95 masks available to the healthcare and essential workers who need them most. </p>

      <p>The Coronavirus will primarily affect those who are already experiencing difficulties. These include the refugees on our external borders, the homeless, the elderly and the sick. The corona crisis may distract us from the suffering of those in need of protection, but the violence and humanitarian catastrophe continue. That's why it's important to stick together, now more than ever. </p>

      <p>Buy a mask for yourself or a friend/beloved person. You can choose your purchase amount to support the cause. 100% of the proceeds go to „Médecins Sans Frontières / <a href="https://www.doctorswithoutborders.org/what-we-do/news-stories/story/msf-steps-response-coronavirus-pandemic-europe" target="_blank">Doctors Without Borders</a>“, to prevent the corona disaster.</p>

      <p>Take care of each other out there!</p>

      <p>Rocco & Andreas</p>

      <div className="funds">
        <div>
          <div className="number">
            {data && data.fundsRaised}€
          </div>
          <div className="label">
            funds raised
          </div>
        </div>
        <div>
          <div className="number">
            {data && data.masksSold}
          </div>
          <div className="label">
            of 150 masks sold
          </div>
        </div>
      </div>

      <div className="purchase">
        <div>
          Choose amount you would like to purchase a mask for
        </div>
        <div>
          <div className="inputs">
            {availablePrices.map(price => (
              <div className="input input--radio" key={price}>
                <input type="radio" name="price" id={`a${price}`} checked={price === selectedPrice} onChange={e => {setSelectedPrice(price); setIsCustom(false)}}/>
                <label htmlFor={`a${price}`}>{price}€</label>
              </div>
            ))}
            <div className="input input--radio">
              <input type="radio" name="price" id={`acustom`} checked={isCustom} onChange={e => {setSelectedPrice(false); setIsCustom(true)}}/>
              <label htmlFor={`acustom`}>
                <input type="number" value={isCustom && selectedPrice} onChange={e => setSelectedPrice(e.target.value)} onFocus={() => {setSelectedPrice(false);setIsCustom(true)}}/>
              </label>
            </div>
          </div>
        </div>
        <div>
          <a href={`http://paypal.me/akkuratstudios/${selectedPrice}`} target="_blank" className="button button--primary" disabled={!selectedPrice || selectedPrice < 15}>
            Purchase Mask
          </a>
        </div>
      </div>
    </div>
  </div>;
}

export default withRouter(Information);
